"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[265],{

/***/ 19265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U8": function() { return /* reexport */ layout_LandingPageLayout; },
  "Ar": function() { return /* reexport */ Layout/* default */.Z; },
  "iZ": function() { return /* reexport */ layout_LayoutWithSidebar; }
});

// UNUSED EXPORTS: MainNav, Sidebar

// EXTERNAL MODULE: ./components/layout/Layout.jsx
var Layout = __webpack_require__(93725);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/SunIcon.js
var SunIcon = __webpack_require__(54346);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/MoonIcon.js
var MoonIcon = __webpack_require__(63771);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/ArrowsUpDownIcon.js
var ArrowsUpDownIcon = __webpack_require__(28591);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/LanguageIcon.js
var LanguageIcon = __webpack_require__(75425);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/UserCircleIcon.js
var UserCircleIcon = __webpack_require__(30097);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/ArrowLeftEndOnRectangleIcon.js
var ArrowLeftEndOnRectangleIcon = __webpack_require__(87300);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(38719);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(33299);
// EXTERNAL MODULE: ./components/icons/index.js + 4 modules
var icons = __webpack_require__(44874);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/@material-tailwind/react/index.js
var _material_tailwind_react = __webpack_require__(59335);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./hooks/index.js + 8 modules
var hooks = __webpack_require__(8617);
// EXTERNAL MODULE: ./context/ThemeContext.js
var ThemeContext = __webpack_require__(70306);
// EXTERNAL MODULE: ./utils/utils.js
var utils = __webpack_require__(14364);
// EXTERNAL MODULE: ./hooks/useApi.js + 56 modules
var useApi = __webpack_require__(4868);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.mjs
var md = __webpack_require__(30080);
;// CONCATENATED MODULE: ./components/layout/LandingPageMainNav.jsx















function LandingPageMainNav() {
    var ref, ref1;
    var router = (0,next_router.useRouter)();
    var data = (0,next_auth_react.useSession)().data;
    var user = (data === null || data === void 0 ? void 0 : data.user) || {};
    var isOnline = (0,hooks/* useOnlineStatus */.kr)();
    var firstLetter = (user === null || user === void 0 ? void 0 : (ref = user.user_name) === null || ref === void 0 ? void 0 : ref.slice(0, 1)) || "U";
    var ref2 = (0,ThemeContext/* useTheme */.F)(), theme = ref2.theme, toggleTheme = ref2.toggleTheme;
    var t = (0,esm/* useTranslation */.$G)("common").t;
    var ref3 = (0,useApi/* useApi */.h)((user === null || user === void 0 ? void 0 : user.tower_id) ? "/towers?id=".concat(user === null || user === void 0 ? void 0 : user.tower_id) : ""), signedInByTower = ref3.data;
    // Memoized language selection handler
    var selectLanguageHandler = (0,react.useCallback)(function() {
        var currentLang = router.locale.toLowerCase();
        router.push(router.asPath, undefined, {
            locale: currentLang === "ar" ? "en" : "ar"
        });
    }, [
        router
    ]);
    var logOut = function() {
        (0,next_auth_react.signOut)();
    };
    var roleOptions = (0,react.useMemo)(function() {
        return [
            {
                label: t("admin_key"),
                value: "admin"
            },
            {
                label: t("user_key"),
                value: "user"
            },
            {
                label: t("flat_owner_key"),
                value: "flat"
            }, 
        ];
    }, [
        t
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        style: {
            zIndex: 9999
        },
        className: "sticky top-0 bg-white dark:bg-gray-800",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-2 sm:px-6",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "relative flex items-center justify-between h-16",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "inset-y-0 left-0 flex items-center sm:hidden"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex items-center justify-start flex-1 sm:items-stretch sm:justify-start",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex items-center flex-shrink-0 w-24 h-16 md:w-52 overflow-hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* MainLogo */.zU, {
                                    className: "cursor-pointer"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "items-center hidden gap-2 md:flex",
                        children: [
                            (signedInByTower === null || signedInByTower === void 0 ? void 0 : signedInByTower.id) && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/dashboard/settings",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text-white px-2 py-1 rounded-md font-bold cursor-pointer bg-primary opacity-75 hover:opacity-100 hidden md:flex",
                                    children: signedInByTower === null || signedInByTower === void 0 ? void 0 : signedInByTower.name
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(_material_tailwind_react.Button, {
                                onClick: selectLanguageHandler,
                                className: "flex items-center justify-center w-8 h-8 px-2 py-2 text-sm bg-gray-200 rounded-full cursor-pointer text-gray-800 hover:bg-gray-300 dark:bg-gray-700 dark:hover:bg-gray-600 dark:text-gray-200",
                                children: router.locale.includes("ar") ? "EN" : "AR"
                            }),
                            theme === "light" && /*#__PURE__*/ (0,jsx_runtime.jsx)(SunIcon/* default */.Z, {
                                onClick: function() {
                                    return toggleTheme("dark");
                                },
                                className: "w-8 h-8 px-2 py-2 mx-2 bg-gray-100 rounded-full cursor-pointer hover:bg-gray-200 dark:bg-gray-500 dark:hover:bg-gray-400"
                            }),
                            theme === "dark" && /*#__PURE__*/ (0,jsx_runtime.jsx)(MoonIcon/* default */.Z, {
                                onClick: function() {
                                    return toggleTheme("light");
                                },
                                className: "w-8 h-8 px-2 py-2 mx-2 text-white bg-gray-100 rounded-full cursor-pointer hover:bg-gray-200 dark:bg-gray-500 dark:hover:bg-gray-400"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "my-2 ml-5 mr-2 text-transparent border-l-2 border-gray-400 rtl:ml-2 rtl:mr-5 h-3/4",
                        children: "."
                    }),
                    (user === null || user === void 0 ? void 0 : user.id) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(_material_tailwind_react.Popover, {
                        placement: "bottom",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(_material_tailwind_react.PopoverHandler, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(_material_tailwind_react.Button, {
                                    className: "flex items-center justify-between gap-4 px-2 text-black bg-transparent shadow-none dark:text-white hover:shadow-none",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "relative",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "w-2 h-2 rounded-full absolute -top-1 -left-1 ".concat(isOnline ? "bg-green-500" : "bg-red-500")
                                                }),
                                                (user === null || user === void 0 ? void 0 : user.img) ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: (0,utils/* generateCloudinaryUrl */.C8)(user.img),
                                                    width: 40,
                                                    height: 40,
                                                    className: " rounded-full",
                                                    alt: user.user_name
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "flex items-center justify-center w-10 h-10 p-2 text-sm uppercase bg-gray-100 rounded-full dark:bg-gray-500",
                                                    children: firstLetter
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col items-center justify-between",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        " ",
                                                        user === null || user === void 0 ? void 0 : user.user_name
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        " ",
                                                        (ref1 = roleOptions.find(function(role) {
                                                            return role.value == (user === null || user === void 0 ? void 0 : user.role);
                                                        })) === null || ref1 === void 0 ? void 0 : ref1.label
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowsUpDownIcon/* default */.Z, {
                                            className: "hidden w-5 md:flex"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(_material_tailwind_react.PopoverContent, {
                                className: " w-auto dark:bg-gray-700 dark:border-gray-400 dark:text-white z-[9999]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(_material_tailwind_react.List, {
                                    className: "p-0",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(_material_tailwind_react.ListItem, {
                                            onClick: function() {
                                                return toggleTheme("".concat(theme === "light" ? "dark" : "light"));
                                            },
                                            className: "gap-4 dark:text-gray-100 hover:text-black active:text-dark md:hidden",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(_material_tailwind_react.ListItemPrefix, {
                                                    children: theme === "light" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(SunIcon/* default */.Z, {
                                                        className: "w-8"
                                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(MoonIcon/* default */.Z, {
                                                        className: "w-8"
                                                    })
                                                }),
                                                t("dark_mode_key")
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(_material_tailwind_react.ListItem, {
                                            onClick: selectLanguageHandler,
                                            className: "gap-4 dark:text-gray-100 hover:text-black active:text-dark md:hidden",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(_material_tailwind_react.ListItemPrefix, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageIcon/* default */.Z, {
                                                        className: "w-8"
                                                    })
                                                }),
                                                router.locale.includes("ar") ? "English" : "عربي"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/dashboard",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(_material_tailwind_react.ListItem, {
                                                as: "a",
                                                className: "gap-4 dark:text-gray-100 hover:text-black active:text-dark",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_material_tailwind_react.ListItemPrefix, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(md/* MdDashboard */.bUq, {
                                                            className: "w-8"
                                                        })
                                                    }),
                                                    t("dashboard_key")
                                                ]
                                            })
                                        }),
                                        user.role !== "flat" && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/dashboard/profile",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(_material_tailwind_react.ListItem, {
                                                as: "a",
                                                className: "gap-4 dark:text-gray-100 hover:text-black active:text-dark",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(_material_tailwind_react.ListItemPrefix, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UserCircleIcon/* default */.Z, {
                                                            className: "w-8"
                                                        })
                                                    }),
                                                    t("profile_key")
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(_material_tailwind_react.ListItem, {
                                            onClick: logOut,
                                            className: "gap-4 dark:text-gray-100 hover:text-black active:text-dark",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(_material_tailwind_react.ListItemPrefix, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftEndOnRectangleIcon/* default */.Z, {
                                                        className: "w-8"
                                                    })
                                                }),
                                                t("sign_out_key")
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/login",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(_material_tailwind_react.Button, {
                            children: t("sign_in_key")
                        })
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/InformationCircleIcon.js
var InformationCircleIcon = __webpack_require__(66692);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/HomeIcon.js
var HomeIcon = __webpack_require__(9047);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/PhoneIcon.js
var PhoneIcon = __webpack_require__(79974);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.mjs
var fa = __webpack_require__(52091);
;// CONCATENATED MODULE: ./components/layout/LandingPageFooter.jsx





function LandingPageFooter() {
    var t = (0,esm/* useTranslation */.$G)("common").t;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: "bg-gray-800 text-white py-10 dark:bg-gray-900 dark:text-gray-200",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container mx-auto px-6",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 md:grid-cols-3 gap-8 items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        "data-aos": "fade-zoom-in",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-2xl font-bold",
                                children: t("Easier")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "mt-2 text-gray-400 dark:text-gray-500",
                                children: t("tower_management_made_simple_key")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center md:items-start",
                        "data-aos": "fade-zoom-in",
                        "data-aos-delay": "200",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "font-semibold text-lg mb-3",
                                children: t("quick_links_key")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "space-y-2",
                                children: [
                                    {
                                        href: "/about",
                                        label: t("aboutUs_key"),
                                        icon: InformationCircleIcon/* default */.Z
                                    },
                                    {
                                        href: "/services",
                                        label: t("services_key"),
                                        icon: HomeIcon/* default */.Z
                                    },
                                    {
                                        href: "/faq",
                                        label: t("faq_key"),
                                        icon: InformationCircleIcon/* default */.Z
                                    },
                                    {
                                        href: "/contact",
                                        label: t("contact_key"),
                                        icon: PhoneIcon/* default */.Z
                                    }, 
                                ].map(function(param, idx) {
                                    var href = param.href, label = param.label, Icon = param.icon;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: href,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex items-center hover:underline text-gray-300 dark:text-gray-300 hover:text-gray-400 dark:hover:text-gray-400",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                                        className: "w-5 h-5 mr-2"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        children: label
                                                    })
                                                ]
                                            })
                                        })
                                    }, idx);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col items-center md:items-start",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                className: "font-semibold text-lg mb-3",
                                children: t("follow_us_key")
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex space-x-4",
                                children: [
                                    {
                                        href: "https://www.facebook.com/abdoelmorsii",
                                        icon: fa/* FaFacebookF */.tBk,
                                        label: "Facebook"
                                    },
                                    {
                                        href: "https://x.com/abdo_elmorsii",
                                        icon: fa/* FaTwitter */.fWC,
                                        label: "X"
                                    },
                                    {
                                        href: "https://www.linkedin.com/in/abdelrahman-a-morsi-163263205",
                                        icon: fa/* FaLinkedinIn */.BUd,
                                        label: "LinkedIn"
                                    }, 
                                ].map(function(param, idx) {
                                    var href = param.href, Icon = param.icon, label = param.label;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: href,
                                        target: "_blank",
                                        "aria-label": label,
                                        className: "p-2 bg-gray-700 hover:bg-gray-600 dark:bg-gray-800 dark:hover:bg-gray-700 rounded-full transition-all",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                            className: "w-5 h-5"
                                        })
                                    }, idx);
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var layout_LandingPageFooter = (LandingPageFooter);

;// CONCATENATED MODULE: ./components/layout/LandingPageLayout.jsx





var LandingPageLayout = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-gray-100 dark:bg-gray-700 min-h-screen",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingPageMainNav, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: "container",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_LandingPageFooter, {})
        ]
    });
};
LandingPageLayout.propTypes = {
    children: (prop_types_default()).node.isRequired
};
/* harmony default export */ var layout_LandingPageLayout = (LandingPageLayout);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/UsersIcon.js
var UsersIcon = __webpack_require__(7543);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/BuildingOfficeIcon.js
var BuildingOfficeIcon = __webpack_require__(14020);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/HomeIcon.js
var esm_HomeIcon = __webpack_require__(42237);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/RocketLaunchIcon.js
var RocketLaunchIcon = __webpack_require__(69864);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/TruckIcon.js
var TruckIcon = __webpack_require__(85508);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/DocumentChartBarIcon.js
var DocumentChartBarIcon = __webpack_require__(47621);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/ChatBubbleLeftIcon.js
var ChatBubbleLeftIcon = __webpack_require__(1671);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/CogIcon.js
var CogIcon = __webpack_require__(87272);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/ChevronRightIcon.js
var ChevronRightIcon = __webpack_require__(31038);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/ArrowRightCircleIcon.js
var ArrowRightCircleIcon = __webpack_require__(96055);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/outline/esm/ArrowLeftCircleIcon.js
var ArrowLeftCircleIcon = __webpack_require__(88125);
// EXTERNAL MODULE: ./components/UI/index.js + 48 modules
var UI = __webpack_require__(36926);
;// CONCATENATED MODULE: ./components/layout/Sidebar.jsx












var Sidebar = /*#__PURE__*/ react.memo(function() {
    var ref = (0,next_auth_react.useSession)(), session = ref.data;
    var admin = (0,utils/* getRole */.cY)(session, "admin");
    var user = (0,utils/* getRole */.cY)(session, "user");
    var flat = (0,utils/* getRole */.cY)(session, "flat");
    var router = (0,next_router.useRouter)();
    var ref1 = (0,react.useState)(null), activeAdminSubMenu = ref1[0], setActiveAdminSubMenu = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,hooks/* useSavedState */.aM)(true, "easier-fixed-side-barr-cache"), 2), fixedSideBar = ref2[0], setFixedSideBar = ref2[1];
    var Links = (0,react.useMemo)(function() {
        return [
            {
                nameAR: "ملخص",
                nameEN: "Overview",
                href: "/dashboard",
                current: router.pathname === "/dashboard",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* Overview */.g2, {
                    className: "w-5 h-5"
                }),
                submenuOpen: false
            },
            {
                nameAR: "المستخدمين",
                nameEN: "Users",
                href: "/dashboard/users",
                current: router.pathname === "/dashboard/users",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(UsersIcon/* default */.Z, {
                    className: "w-5 h-5"
                }),
                submenuOpen: false,
                omit: !admin
            },
            {
                nameAR: "الابراج",
                nameEN: "Towers",
                href: "/dashboard/towers",
                current: router.pathname === "/dashboard/towers",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildingOfficeIcon/* default */.Z, {
                    className: "w-5 h-5"
                }),
                submenuOpen: false,
                omit: flat
            },
            {
                nameAR: "الشقق",
                nameEN: "Flats",
                href: "/dashboard/flats",
                current: router.pathname === "/dashboard/flats",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_HomeIcon/* default */.Z, {
                    className: "w-5 h-5"
                }),
                submenuOpen: false,
                omit: flat
            },
            {
                nameAR: "ألاجرأت",
                nameEN: "Actions",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(RocketLaunchIcon/* default */.Z, {
                    className: "w-5 h-5"
                }),
                submenuOpen: activeAdminSubMenu === 4,
                submenu: [
                    {
                        nameAR: "الرصيد الافتتاحي",
                        nameEN: "Opening Balance",
                        href: "/dashboard/opening-balance",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TruckIcon/* default */.Z, {
                            className: "w-5 h-5"
                        }),
                        current: router.pathname === "/dashboard/opening-balance"
                    },
                    {
                        nameAR: "المصاريف التقديريه",
                        nameEN: "Estimated expenses",
                        href: "/dashboard/estimated-expenses",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TruckIcon/* default */.Z, {
                            className: "w-5 h-5"
                        }),
                        current: router.pathname === "/dashboard/estimated-expenses"
                    },
                    {
                        nameAR: "التسوية",
                        nameEN: "Settlement",
                        href: "/dashboard/settlement",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TruckIcon/* default */.Z, {
                            className: "w-5 h-5"
                        }),
                        current: router.pathname === "/dashboard/settlement"
                    }, 
                ],
                omit: flat
            },
            {
                nameAR: "التقارير",
                nameEN: "Reports",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(DocumentChartBarIcon/* default */.Z, {
                    className: "w-5 h-5"
                }),
                submenuOpen: activeAdminSubMenu === 5,
                submenu: [
                    {
                        nameAR: "شهري",
                        nameEN: "Monthly",
                        href: "/dashboard/monthly-report",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TruckIcon/* default */.Z, {
                            className: "w-5 h-5"
                        }),
                        current: router.pathname === "/dashboard/monthly-report"
                    },
                    {
                        nameAR: "سنوي",
                        nameEN: "Annually",
                        href: "/dashboard/annually-report",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TruckIcon/* default */.Z, {
                            className: "w-5 h-5"
                        }),
                        current: router.pathname === "/dashboard/annually-report"
                    },
                    {
                        nameAR: "ارصدت البرج",
                        nameEN: "Tower balances",
                        href: "/dashboard/tower-balances",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TruckIcon/* default */.Z, {
                            className: "w-5 h-5"
                        }),
                        current: router.pathname === "/dashboard/tower-balances"
                    },
                    {
                        nameAR: "سجل المستخدم",
                        nameEN: "User Log",
                        href: "/dashboard/user-log",
                        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(TruckIcon/* default */.Z, {
                            className: "w-5 h-5"
                        }),
                        current: router.pathname === "/dashboard/user-log",
                        omit: !admin
                    }, 
                ]
            },
            {
                nameAR: "دردشة",
                nameEN: "Chat",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChatBubbleLeftIcon/* default */.Z, {
                    className: "w-5 h-5"
                }),
                href: "/dashboard/chat",
                current: router.pathname === "/dashboard/chat",
                submenuOpen: false
            },
            {
                nameAR: "الإعدادات",
                nameEN: "Settings",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CogIcon/* default */.Z, {
                    className: "w-5 h-5"
                }),
                href: "/dashboard/settings",
                current: router.pathname === "/dashboard/settings",
                submenuOpen: false,
                omit: !admin
            }, 
        ];
    }, [
        admin,
        flat,
        router.pathname,
        activeAdminSubMenu
    ]);
    return(// w-14 hover:w-64
    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "min-h-[calc(100vh_-_4rem)] group flex flex-col flex-shrink-0  transition-all duration-300 bg-white w-14 hover:w-64 ".concat(fixedSideBar ? "md:w-64 opened" : "", " sidebar dark:bg-gray-800 "),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col fixed",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: "flex flex-col py-4 space-y-1 overflow-y-auto no-scrollbar border-y-2 border-gray-100 dark:border-gray-700",
                    children: Links === null || Links === void 0 ? void 0 : Links.map(function(tab, index) {
                        return !tab.omit ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: tab.submenu ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "relative flex flex-row items-center h-11",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                            "aria-label": "sidebar toggle",
                                            onClick: function() {
                                                return setActiveAdminSubMenu(function() {
                                                    return tab.submenuOpen ? null : index;
                                                });
                                            },
                                            className: "w-full focus:outline-none relative flex h-11 flex-row items-center border-l-4 pr-6 rtl:pr-4 rtl:border-l-0 rtl:border-r-4 dark:text-white hover:text-primary dark:hover:text-primary hover:border-primary ".concat(tab.submenuOpen ? "!text-primary border-primary" : "border-transparent"),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "inline-flex items-center justify-center ml-4",
                                                    children: tab.icon
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "ml-2 text-sm tracking-wide truncate",
                                                    children: router.locale === "en" ? tab.nameEN : tab.nameAR
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "absolute inset-y-0 flex items-center pl-2 duration-300 opacity-0 group-hover:opacity-100 md:group-[.opened]:opacity-100 transition-all md:hover::opacity-100 arrow-icon right-2 rtl:pr-2 rtl:right-auto rtl:left-2",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon/* default */.Z, {
                                                        className: "duration-200 w-5 h-5 ".concat(tab.submenuOpen ? "rtl:rotate-90" : "rotate-90 rtl:-rotate-180")
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    tab.submenuOpen && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                        className: "flex flex-col px-2 py-4 space-y-1",
                                        children: tab.submenu.map(function(subTab) {
                                            return !subTab.omit ? /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "tab_link cursor-pointer",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: subTab.href,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                        className: "".concat(subTab.current ? "!text-primary !border-primary" : "border-transparent hover:text-primary", " dark:text-white hover:border-primary dark:hover:text-primary text-white-600 relative flex h-11 flex-row items-center border-l-4 focus:outline-none rtl:border-l-0 rtl:border-r-4 rtl:pr-2"),
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "inline-flex items-center justify-center ml-4 duration-500 sub-menu-icon",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowRightCircleIcon/* default */.Z, {
                                                                    className: "w-5 h-5 rtl:rotate-180"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "ml-2 text-sm tracking-wide truncate",
                                                                children: router.locale === "en" ? subTab.nameEN : subTab.nameAR
                                                            })
                                                        ]
                                                    })
                                                })
                                            }, subTab.href) : null;
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cursor-pointer",
                                onClick: function() {
                                    return activeAdminSubMenu && setActiveAdminSubMenu(null);
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: tab.href,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: "".concat(tab.current ? "!text-primary border-primary" : "border-transparent hover:text-primary", " dark:text-white hover:border-primary dark:hover:text-primary text-white-600 relative flex h-11 flex-row items-center border-l-4 pr-6 focus:outline-none rtl:border-l-0 rtl:border-r-4 rtl:pr-4"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "inline-flex items-center justify-center ml-4",
                                                children: tab.icon
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "ml-2 text-sm tracking-wide truncate",
                                                children: router.locale === "en" ? tab.nameEN : tab.nameAR
                                            })
                                        ]
                                    })
                                })
                            })
                        }, tab.nameEN) : null;
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(UI/* Button */.zx, {
                    onClick: function() {
                        return setFixedSideBar(!fixedSideBar);
                    },
                    className: "mx-auto mt-auto text-xs tracking-wide text-center truncate text-primary",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLeftCircleIcon/* default */.Z, {
                        className: " transition-all duration-300 hover:scale-110 ".concat(!fixedSideBar ? "-rotate-180 rtl:rotate-0" : "rtl:rotate-180"),
                        width: 25
                    })
                })
            ]
        })
    }));
});
Sidebar.displayName = "Sidebar";
/* harmony default export */ var layout_Sidebar = (Sidebar);

;// CONCATENATED MODULE: ./components/layout/LayoutWithSidebar.jsx



var LayoutWithSidebar = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_Sidebar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full m-2 sm:m-8 overflow-hidden dark:text-white ",
                children: children
            })
        ]
    });
};
/* harmony default export */ var layout_LayoutWithSidebar = (LayoutWithSidebar);
LayoutWithSidebar.propTypes = {
    children: (prop_types_default()).node.isRequired
};

// EXTERNAL MODULE: ./components/layout/MainNav.jsx + 2 modules
var MainNav = __webpack_require__(36809);
;// CONCATENATED MODULE: ./components/layout/index.js







/***/ })

}]);